import { Box, Button, Grid, Tooltip, Typography, styled } from "@mui/material";
import { useEffect } from "react";
import LinkButton from "../../components/link-button/link-button";
import PageTemplate from "../../components/template/page-template";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { routeMapping } from "../../route.config";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import ListBuilderTable from "./component/list-builder-table";
import {
    listBuilderTableInitAction,
    listBuilderTableStopAutoRefreshAction,
} from "./redux/list-builder-table-page.action";

const ListBuilderTablePage = ({ className }: IWithClassName) => {
    const dispatch = useAppDispatch();
    const { listBuilders, canCreateMoreListBuilders } = useAppSelector(
        (state) => state.listBuilderTable.listBuilderTable,
    );
    useEffect(() => {
        dispatch(listBuilderTableInitAction());
        return () => {
            dispatch(listBuilderTableStopAutoRefreshAction());
        };
    }, [dispatch]);

    return (
        <PageTemplate pageTitle="List Builder">
            <Grid className={className}>
                <Typography className="page-title" component="h6">
                    List Builders ({listBuilders?.total})
                </Typography>
                <Box className="header-box">
                    <Tooltip
                        title={
                            canCreateMoreListBuilders
                                ? ""
                                : "You can't create more list builders"
                        }
                        disableHoverListener={canCreateMoreListBuilders}
                    >
                        <span>
                            <Button
                                variant="outlined"
                                size="small"
                                color="secondary"
                                className="text-center button-style"
                                component={LinkButton}
                                href={routeMapping.createListBuilder.path}
                                disabled={!canCreateMoreListBuilders}
                            >
                                New list builder
                            </Button>
                        </span>
                    </Tooltip>
                </Box>
            </Grid>
            <ListBuilderTable />
        </PageTemplate>
    );
};

export default styled(ListBuilderTablePage)(({ theme }: IWithThemeProps) => ({
    ".page-title": {
        color: theme?.palette.text.primary,
        fontSize: 20,
        marginBottom: theme?.spacing(4),
        fontWeight: 600,
        textTransform: "uppercase",
    },
    ".header-box": {
        display: "grid",
        gridTemplateColumns: "1fr 4fr",
        gap: 20,
        marginBottom: theme?.spacing(7.25),
        p: {
            color: theme?.palette.announcement.primaryColor,
            fontSize: 22,
        },
        ".button-style": {
            height: 40,
            margin: "auto",
        },
    },
}));
